import React, {useEffect, useState} from "react";
import CmsHelper, {PickProgramPageHelper} from "../../../Utilities/CmsHelpers";
import FlowContainer from "../../../PickProgram/FlowElements/FlowContainer";
import {useCms} from "../../../../context/CmsContext";
import GoogleAnalytics from "../../../../analytics/GoogleAnalytics";
import AwsApiService from "../../../../services/AwsApiService";
import {useAccount} from "../../../../context/AccountContext";
import AccountsService from "../../../../services/AccountsService";
import {useNavigate} from "react-router-dom";
import UserService from "../../../../services/UserService";
import usePaymentProvider from "../../../../services/PaymentProvider.ts";
import EvergentErrors from "../../../../services/Evergent/EvergentErrors.ts";
import {useProductFlowContext} from "../../../../context/ProductFlowContext";

export default function RegistrationFlow({packages, couponExists, handleNextStep,
                                             contestSession, promoTargetDisplayName}) {
    const account = useAccount();
    const {pickProgramData} = useCms();
    const paymentProvider = usePaymentProvider();

    const { setOnNext, setSelectedProduct } = useProductFlowContext()

    const navigate = useNavigate();

    const [products, setProducts] = useState([])

    useEffect(()=>{
        let products = [...packages];

        if (!(!!couponExists) && !!promoTargetDisplayName) {
            const targetDisplayNames = JSON.parse(promoTargetDisplayName);
            products = products.filter(item1 => targetDisplayNames.some(item2 => item1.displayName === item2))
        }

        if(contestSession){
            products = products.filter(product => product.displayName !== "Lite")
        }

        setProducts(products);

    }, [packages, couponExists, contestSession, promoTargetDisplayName])

    const getPrice = (price) => {
        try {
            let res = price/100;
            if(!Number.isNaN(res))
                return res;
        } catch (e) {
        }
        return undefined;
    }


    const [loading, setLoading] = useState(false);

    const onNextAction = async (product, setCardInUse, setError) =>{
        let addonEligible;
        if(!!product?.addons){
            addonEligible = product.addons;
            delete product.addons
        }

        let request = {
            pricePoint: product.pricePoint,
        };

        if(product.addonPricePoint){
            request = {
                ...request,
                addonPricePoint: product.addonPricePoint,
            }
        }

        if (!!couponExists) {
            request = {
                ...request,
                couponCode: couponExists,
            };
        }

        if(!!product?.promotions){
            request = {
                ...request,
                promotionId: product?.promotions?.[0],
            };
        }

        account.setChosenProgramName(
            packages.find((obj) => obj.productId === product.productId).name
        );
        GoogleAnalytics.onSelectPackage();
        AwsApiService.onPickProgram();


        sessionStorage.removeItem("selectedProgramId");

        return AccountsService.subscribe(request)
            .then((response) => {
                if (sessionStorage.getItem("discount-coupon")) {
                    sessionStorage.removeItem("discount-coupon");
                }
                handleNextStep(true);

                if(response.data.code === 2){
                    const newProduct = {
                        skuName : "Free",
                        skuId : "Free",
                        prodAttribute: "00000",
                        price: 0
                    };
                    account.setupAnalyticsEvProductConvertion(newProduct);
                    sessionStorage.setItem("kc_resolve_token", response.data.token);
                    navigate("/CongratsPage");
                } else {
                    window.addEventListener("message", function handleMessage(event){
                        const iframeUrl = new URL(response.data.uri);
                        if (!iframeUrl || (event.origin !== iframeUrl?.origin && event.origin !== window.location.origin)) {
                            return;
                        }

                        let data;
                        try {
                            data = JSON.parse(event.data);
                        }catch (e){
                            data = event.data;
                        }

                        AccountsService.sendSubscriptionResult(data)
                            .then()
                            .catch(err => console.error("Error sending subscription result:", err));

                        if(data?.status !== undefined) {
                            console.log("Successful flow", parseInt(data?.status))
                            window.removeEventListener("message", handleMessage);
                            if ((parseInt(data.status) === 1)) {
                                AccountsService.checkSubscriptionPostAction()
                                    .then(r => {
                                        let promotionId = r?.data?.couponsInformation?.[0]?.id;
                                        let promotionName = r?.data?.couponsInformation?.[0]?.name;
                                        const newProduct = {
                                            skuName : r?.data?.subscription?.product?.name,
                                            skuId : r?.data?.subscription?.product?.product_price_point_handle,
                                            prodAttribute: r?.data?.subscription?.productAttribute,
                                            promotionId: promotionId,
                                            promotionName: promotionName,
                                            price: getPrice(r?.data?.renewalPreview?.total_amount_due_in_cents),
                                            priceWithTax: r?.data?.subscription?.product?.price_with_tax
                                        };
                                        account.setupAnalyticsEvProductConvertion(newProduct);
                                        if(r?.data?.subscription?.addons.length > 0){
                                            let element = r?.data?.subscription?.addons[0];
                                            const newProductAddon = {
                                                skuName : element?.product?.name,
                                                skuId : element?.product?.product_price_point_handle,
                                                prodAttribute: element?.productAttribute,
                                                price: element?.product?.price_with_tax,
                                                priceWithTax: element?.product?.price_with_tax
                                            };
                                            account.setupAnalyticsAddonProductConvertion(newProductAddon);
                                        }
                                        sessionStorage.setItem("kc_resolve_token", r.data.token);
                                    })
                                    .catch((err) => {
                                        console.error(err)
                                    })
                                    .finally(() => {
                                        handleNextStep(true);
                                        if (!!couponExists) {
                                            sessionStorage.setItem("coupon-success", true)
                                        }
                                        if(data?.mlink){
                                            sessionStorage.setItem("addon-mlink", JSON.stringify({
                                                mlink: data?.mlink,
                                                addon: addonEligible.find(addon => request.addonPricePoint === addon.skuORQuickCode)}))
                                        }else{
                                            if(!!addonEligible){
                                                sessionStorage.setItem("addon-eligible", JSON.stringify(addonEligible));
                                            }
                                        }
                                        if (UserService.isSubscriptionAction()) {
                                            navigate("/CongratsPage");
                                        } else {
                                            navigate("/CongratsPage");
                                        }
                                    })
                            }
                            else if(parseInt(data.status) === 0){
                                if(data.errorCode === EvergentErrors.REQUEST_TERMINATED.value){
                                    window.location.replace("/PickProgram"); //replace so user cant go back to /cartPage without any state
                                }
                            }else if(parseInt(data.status) === 400){
                                window.removeEventListener("message", handleMessage);
                            }
                        }
                    });
                    navigate(paymentProvider.paymentForm, {state: { uri: response.data.uri}})
                }
            })
            .catch((err) => {
                //TODO handle error
            })
    }

    const onNext = (product, ...props) => {
        if(product?.addons?.length > 0){
            setOnNext(() => async (addons)=>{
                return onNextAction({...product, ...addons}, ...props);
            })

            setSelectedProduct(product)
            navigate("/pickAddon")
        }else{
            setLoading(true)
            onNextAction(product, ...props)
                .finally(()=>{
                    setLoading(false)
                });
        }
    }
    return <>
        <FlowContainer packages={products}
                       loading={loading}
                       update={false}
                       couponExists={!!couponExists}
                       contestState={contestSession}
                       cmsData={PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.REGISTRATION)}
                       onNext={onNext}
        />
    </>
}